import { OrderDetailAttributes, VisitAttributes } from "@albatrosdeveloper/ave-models-package";
import { OrderStatusERPEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/order-status-erp.enum";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/status.enum";
import { CommonModule, DecimalPipe } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatChipsModule } from "@angular/material/chips";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialog } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import {
  MatPaginatorIntl,
  MatPaginatorModule,
} from "@angular/material/paginator";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import { IPaginationResult } from "app/common/interfaces";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import {
  ExportDialogComponent,
  ExportOptions,
} from "app/layout/export-overlay";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { CompanyService } from "app/modules/components/configuration/company/company.service.service";
import { BusinessPartnersFiltersComponent } from "app/modules/components/filters/business-partners-filters/business-partners-filters.component";
import { ConfigurationFiltersComponent } from "app/modules/components/filters/configuration-filters/configuration-filters.component";
import { DatesFiltersComponent } from "app/modules/components/filters/dates-filters/dates-filters.component";
import { DocumentsFiltersComponent } from "app/modules/components/filters/documents-filters/documents-filters.component";
import { IFilters } from "app/modules/components/filters/interfaces/filterInterface";
import { MaterialsManagementFiltersComponent } from "app/modules/components/filters/materials-management-filters/materials-management-filters.component";
import { RoutesFiltersComponent } from "app/modules/components/filters/routes-filters/routes-filters.component";
import { StatusFiltersComponent } from "app/modules/components/filters/status-filters/status-filters.component";
import { DocumentFlowButtonComponent } from "app/modules/shared/document-flow-button/document-flow-button.component";
import { CompanyCurrencyPipe } from "app/pipes/currency.pipe";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import { FormatOtherDateHourPipe } from "app/pipes/other-date.pipe";
import { UserRouteDisplayComponent } from "app/shared/components/user-route-display/user-route-display.component";
import { UnitMeasureDisplayComponent } from "app/shared/components/unit-measure-display/unit-measure-display.component";
import { DecimalConfigService } from "app/services/decimal-config.service";

// Smart Grid imports
import {
  ColDef,
  GridConfig,
  PageChangedEvent,
  SortChangedEvent,
  GridReadyEvent,
} from 'app/shared/components/smart-grid';

// Cell Renderers
import { RouteUserCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/route-user-cell-renderer/route-user-cell-renderer.component';
import { CustomerCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/customer-cell-renderer/customer-cell-renderer.component';
import { MaterialCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/material-cell-renderer/material-cell-renderer.component';
import { QuantityCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/quantity-cell-renderer/quantity-cell-renderer.component';
import { DateHourCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/date-hour-cell-renderer/date-hour-cell-renderer.component';
import { CurrencyCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/currency-cell-renderer/currency-cell-renderer.component';
import { ActionsCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/actions-cell-renderer/actions-cell-renderer.component';
import { DeliverySerialNavigationCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/delivery-serial-navigation-cell-renderer/delivery-serial-navigation-cell-renderer.component';
import { debounceTime, skip, Subscription } from "rxjs";
import { ORDER_DELIVERY_EXPORT_ID, ORDER_DELIVERY_TITLE } from "../order-customer/exports/order-customer.constants";
import { DateHelper } from "app/utils/date.helper";
import { getCode } from "app/utils/method";
import { OrderCustomerService } from "../order-customer/order-customer.service";
import { SmartGridComponent } from "app/shared/components/smart-grid";
import { OrderCustomerExport } from "../order-customer/exports/order-customer.export";
import { BusinessPartnerCellRendererComponent } from "app/modules/components/monitor/monitor-routes/cell-renderers/business-partner-cell-renderer.component";
import { TripLiquidationCellRendererComponent } from "../../liquidations/cell-renderers/trip-liquidation-cell-renderer.component";
import { TripCellRendererComponent } from "../../visits/visit-report/cell-renderers/trip-cell-renderer.component";
import { Router } from "@angular/router";


@Component({
  selector: "app-delivery",
  standalone: true,
  imports: [
    CommonModule,
    HoverMenuDirective,
    MatSidenavContainer,
    MatButtonModule,
    MatIconModule,
    MatChipsModule,
    MatMenuModule,
    FilterComponent,
    MatFormFieldModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    FilterSectionComponent,
    StatusFiltersComponent,
    MaterialsManagementFiltersComponent,
    DatesFiltersComponent,
    ConfigurationFiltersComponent,
    DocumentsFiltersComponent,
    RoutesFiltersComponent,
    BusinessPartnersFiltersComponent,
    SmartGridComponent,
  ],
  providers: [DecimalPipe, OrderCustomerExport],
  templateUrl: "./delivery.component.html",
})
export class DeliveryHComponent implements OnInit, OnDestroy {
  private isInitialized = false;
  type = "DT011";
  private decimalPipe = new DecimalPipe("en-US");
  OrderStatusERPEnum = OrderStatusERPEnum;
  StatusEnum = StatusEnum;

  // Smart Grid Configuration
  columnDefs: ColDef<any>[] = [
    {
      colId: "routeUser",
      field: "subRoute.code" as any,
      pinned: "left",
      headerName: "Ruta",
      cellRenderer: RouteUserCellRendererComponent,
      minWidth: 300,
      sortable: true,
      filterOptions: {
        valueExtractor: (item: any) => {
          const subRoute = item.subRoute;
          const user = item.user;
          const routeName = subRoute?.name ?? "-";
          const userName = user?.name ?? "-";
          return `${routeName} - ${userName}`;
        },
        customFilterFn: (rowData: any, filterValue: string) => {
          const subRoute = rowData.subRoute;
          const user = rowData.user;
          const routeName = subRoute?.name ?? "-";
          const userName = user?.name ?? "-";
          const displayValue = `${routeName} - ${userName}`;
          if (!displayValue || displayValue === "- - -") return !filterValue;
          return displayValue === filterValue;
        },
      },
    },    
    {
        field: 'trip.id',
        headerName: 'Viaje',
        minWidth: 150,
        sortable: true,
        cellRenderer: TripCellRendererComponent,
        cellRendererParams: {
          onTripClick: (data: any) => this.goToTravel(data)
        }
    },
    {
      field: "serials",
      headerName: "Nro. Doc.",
      cellRenderer: DeliverySerialNavigationCellRendererComponent,
      cellRendererParams: {
        documentType: this.type, // 'DT011' (Entregas)
      },
      minWidth: 160,
      sortable: true,
    },
    {
      field: "date",
      headerName: "Fecha",
      cellRenderer: DateHourCellRendererComponent,
      minWidth: 180,
      sortable: true,
      filterOptions: {
        valueExtractor: (item: any) => {
          const date = item.date;
          if (!date) return "-";
          return new Date(date).toLocaleDateString("es-ES");
        },
        customFilterFn: (rowData: any, filterValue: string) => {
          const date = rowData.date;
          if (!date) return !filterValue;
          const formattedDate = new Date(date).toLocaleDateString("es-ES");
          return formattedDate === filterValue;
        },
      },
    },
    {
       field: "soldTo.name",
       headerName: "Pagador/Receptor",
       cellRenderer: BusinessPartnerCellRendererComponent,
       autoSize: true,
       minWidth: 250, // Much wider for code + long name
       sortable: true,
       filterOptions: {
         // Display customer name in filter dropdown instead of code
         // Note: Requires shipToName field to be present in row data
         valueExtractor: (item: any) => item?.soldTo?.name,
         customFilterFn(rowData, filterValue) {
           const rowCustomer = rowData?.soldTo?.name;
           if (!rowCustomer) return !filterValue;
 
           return rowCustomer === filterValue;
         },
       },
     },
    {
      field: "materialName.name" as any,
      headerName: "Material",
      cellRenderer: MaterialCellRendererComponent,
      minWidth: 300,
      sortable: true,
      filterOptions: {
        valueExtractor: (item: any) => {
          return item.materialName?.name ?? "-";
        },
        customFilterFn: (rowData: any, filterValue: string) => {
          const value = rowData.materialName?.name;
          if (!value || value === "-") return !filterValue;
          return value === filterValue;
        },
      },
    },
    {
      field: "soldQuantity",
      headerName: "Cantidad",
      cellRenderer: QuantityCellRendererComponent,
      cellRendererParams: {
        getUMPActive: () => this.UMPActive,
      },
      minWidth: 180,
      sortable: true,
    },
    {
      field: "unitPrice",
      headerName: "Precio",
      cellRenderer: CurrencyCellRendererComponent,
      minWidth: 120,
      sortable: true,
      cellClass: "text-right",
      filterOptions: this.createCurrencyFilterOptions("unitPrice"),
    },
    {
      field: "subTotal",
      headerName: "Subtotal",
      cellRenderer: CurrencyCellRendererComponent,
      minWidth: 120,
      sortable: true,
      cellClass: "text-right",
      filterOptions: this.createCurrencyFilterOptions("subTotal"),
    },
    {
      field: "total",
      headerName: "Total",
      cellRenderer: CurrencyCellRendererComponent,
      minWidth: 120,
      sortable: true,
      cellClass: "text-right",
      filterOptions: this.createCurrencyFilterOptions("total"),
    },
    {
      colId: "actions",
      headerName: "",
      cellRenderer: ActionsCellRendererComponent,
      cellClass: "text-center",
      headerClass: "text-center",
      minWidth: 80,
      width: 80,
      sortable: false,
      pinned: "right",
    },
  ];

  gridConfig: GridConfig<any> = {
    rowIdField: "_id" as any,
    emptyState: {
      message: "No encontramos tus resultados!",
      showIcon: true,
    },
    pagination: {
      enabled: true,
      mode: "api",
      pageSize: 50,
      pageSizeOptions: [50, 100, 150, 200],
      showPaginator: true,
    },
    sorting: {
      enabled: true,
      mode: "api",
      multiColumn: false,
      defaultSort: [{ field: "_id" as any, direction: "desc" }],
    },
    search: {
      enabled: false,
    },
    columnFilters: {
      enabled: true,
      mode: "local",
    },
    columnVisibility: {
      enabled: false, // Disabled - now in settings panel
    },
    selection: {
      enabled: false,
    },
    autoSizing: {
      enabled: true,
      includeHeaders: true,
      skipHidden: true,
      padding: 40, // Increased for more spacing
    },
    styling: {
      maxHeight: "85vh",
      minHeight: "80vh",
      density: "comfortable",
      fontSize: "12px",
      cellPaddingX: "3px",
      cellPaddingY: "3px",
    },
    settingsPanel: {
      enabled: true,
      position: "right",
      enableColumnVisibility: true,
      defaultDensity: "compact",
    },
  };

  // Data
  data: OrderDetailAttributes[] = [];
  loading: boolean = false;

  //#region Filter
  filter = {
    dateini: new Date(),
    dateend: new Date(),
  };

  totalItems: number = 0;
  search: string = "";
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof OrderDetailAttributes = "_id";
  sortDirection: "ASC" | "DESC" = "DESC";
  //#endregion

  //#region properties
  range = new FormGroup({
    start: new FormControl<Date | null>(new Date()),
    end: new FormControl<Date | null>(new Date()),
  });

  //BUSCADOR
  searchSubscription: Subscription;
  //#endregion

  getCode = getCode;
  UMPActive: boolean;
  form: FormGroup;
  //Para filtros
  selectedStatuses: number[] = [];

  // Estados ERP
  selectedERPStatuses: number[] = [];

  selectedCustomerType: string[] = [];

  loadConfigData = false;
  loadDocumentsData = false;
  loadRoutesData = false;
  loadBusinessPartnersData = false;
  loadMaterialsData = false;

  constructor(
    private orderCustomer: OrderCustomerService,
    private readonly searchService: SearchService,
    private readonly orderCustomerExport: OrderCustomerExport,
    private snackBar: MatSnackBar,
    private readonly companyService: CompanyService,
    private matDialog: MatDialog,
    private fb: FormBuilder,
    private companyCurrencyPipe: CompanyCurrencyPipe,
    private decimalConfigService: DecimalConfigService,
    private readonly router: Router
  ) {
    const today = new Date();
    this.form = this.fb.group({
      start: [today],
      end: [today],
      startTrip: [],
      endTrip: [],
      companyId: [],
      salesOfficeId: [],
      documentClassId: [],
      subRouteId: [],
      assignedUserId: [],
      payingBusinessPartnerId: [],
      receivingBusinessPartnerId: [],
      warehouseId: [],
      end_startTrip: [],
      end_endTrip: [],
      soldToControl: [],
      searchReceivingBusinessPartner: [],
      searchAssignedUser: [],
      materialGroupId: [[]],
      materialId: [],
      pickerUpload_start: [],
      pickerUpload_end: []
    });
  }

  goToTravel(element: VisitAttributes) {
      if (element.trip?.id) {
        const queryParams = { tripId: element.trip.id };
        const urlTree = this.router.createUrlTree(['monitor', 'principal-screen'], { queryParams });
        const absoluteUrl = window.location.origin + this.router.serializeUrl(urlTree);
        window.open(absoluteUrl, '_blank');
      }
    }

  private formatCurrency(value: number): string {
    if (value == null) return "-";
    const decimals = this.decimalConfigService.getDecimals();
    const formattedNum =
      this.decimalPipe.transform(value, `1.${decimals}-${decimals}`) ?? "-";
    if (formattedNum === "-") return "-";
    const symbol = this.companyCurrencyPipe.transform("symbol");
    return `${symbol} ${formattedNum}`;
  }

  private createCurrencyFilterOptions(fieldPath: string) {
    return {
      valueExtractor: (item: any) => {
        const value = item[fieldPath];
        return this.formatCurrency(value);
      },
      customFilterFn: (rowData: any, filterValue: string) => {
        const value = rowData[fieldPath];
        const formattedValue = this.formatCurrency(value);
        if (!formattedValue || formattedValue === "-") return !filterValue;
        return formattedValue === filterValue;
      },
    };
  }

  onConfigExpanded(): void {
    this.loadConfigData = true;
  }

  onDocumentsExpanded(): void {
    this.loadDocumentsData = true;
  }

  onRoutesExpanded(): void {
    this.loadRoutesData = true;
  }

  onBusinessPartnersExpanded(): void {
    this.loadBusinessPartnersData = true;
  }

  onMaterialsExpanded(): void {
    this.loadMaterialsData = true;
  }

  ngOnInit(): void {
    this.onHandleSearch();
    this.fetchCompanies();
    this.getList();
    this.isInitialized = true;
  }

  onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .pipe(skip(1), debounceTime(300))
      .subscribe((term) => {
        if (this.isInitialized) {
          this.pageIndex = 1;
          this.search = term;
          this.onFilter();
        }
      });
  }

  private getSortField(): keyof OrderDetailAttributes {

    return this.sortActive;
  }
  private fetchCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      if (res.data.length === 1) {
        this.UMPActive = res.data[0].UMPActive;
        this.companyService.setActiveCompany(res.data[0]);
      }
    });
  }

  onFilter() {
    this.getList();
  }

  onClearFilter() {
    this.form.reset({
      start: new Date(),
      end: new Date(),
    });
    this.onFilter();
  }

  /**
   * Smart Grid: Handle page change event (API mode)
   */
  onPageChanged(event: PageChangedEvent): void {
    this.pageIndex = event.pageIndex + 1; // Convert 0-based to 1-based
    this.pageSize = event.pageSize;
    this.getList();
  }

  /**
   * Smart Grid: Handle sort change event (API mode)
   */
  onSortChanged(event: SortChangedEvent<any>): void {
    if (event.sortStates.length > 0) {
      const sortState = event.sortStates[0];
      this.sortActive = sortState.field as keyof OrderDetailAttributes;
      this.sortDirection = sortState.direction === "asc" ? "ASC" : "DESC";
    } else {
      this.sortActive = "_id";
      this.sortDirection = "DESC";
    }
    this.getList();
  }

  /**
   * Smart Grid: Handle grid ready event
   */
  onGridReady(event: GridReadyEvent<any>): void {
    // Can be used for additional initialization if needed
  }

  getList() {
    this.loading = true;
    let options = {
      currentPage: this.pageIndex,
      limitPerPage: this.pageSize,
      search: this.search,
      sort: this.getSortField(),
      sortDirection: this.sortDirection,
    };

    let filter: IFilters = {
      type: this.type,
      startDate: DateHelper.getStartOfDay(this.form.get("start")?.value),
      endDate:
        DateHelper.getEndOfDay(this.form.get("end")?.value) ??
        DateHelper.getEndOfDay(this.form.get("start")?.value) ??
        null,
      startTrip: DateHelper.getStartOfDay(this.form.get("startTrip")?.value),
      endTrip:
        DateHelper.getEndOfDay(this.form.get("endTrip")?.value) ??
        DateHelper.getEndOfDay(this.form.get("startTrip")?.value) ??
        null,
      end_startTrip: DateHelper.getStartOfDay(
        this.form.get("end_startTrip")?.value
      ),
      end_endTrip:
        DateHelper.getEndOfDay(this.form.get("end_endTrip")?.value) ??
        DateHelper.getEndOfDay(this.form.get("end_startTrip")?.value) ??
        null,
      pickerUpload_start: DateHelper.getStartOfDay(
        this.form.get("pickerUpload_start")?.value
      ),
      pickerUpload_end: DateHelper.getEndOfDay(this.form.get("pickerUpload_end")?.value) ??
      DateHelper.getEndOfDay(this.form.get("pickerUpload_start")?.value) ??
      null,
      companyId: this.form.get("companyId")?.value,
      salesOfficeId: this.form.get("salesOfficeId")?.value,
      warehouseId: this.form.get("warehouseId")?.value, //
      documentClass: this.form.get("documentClassId")?.value,
      subRouteId: this.form.get("subRouteId")?.value, //
      soldTo: this.form.get("payingBusinessPartnerId")?.value,
      shipTo: this.form.get("receivingBusinessPartnerId")?.value,
      seller: this.form.get("assignedUserId")?.value,
      status: this.selectedStatuses ? this.selectedStatuses : null,
      statusERP: this.selectedERPStatuses.length
        ? this.selectedERPStatuses
        : null,
      typeCustomer: this.selectedCustomerType.length
        ? this.selectedCustomerType
        : null,
      materialGroupId: this.form.get("materialGroupId").value,
      materialId: this.form.get("materialId").value,
      ordersToFilter: null,
    };

    this.orderCustomer.findAllWithCount(options, filter).subscribe({
      next: (res: IPaginationResult<OrderDetailAttributes>) => {
        this.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.loading = false;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener reporte",
          "Cerrar",
          { duration: 5000 }
        );
        this.loading = false;
      },
    });
  }

  //#region Action
  onExportButtonPressed() {
    if (!this.orderCustomerExport.canStartTask()) return;
    const dialogRef = this.matDialog.open(ExportDialogComponent, {
      data: { title: ORDER_DELIVERY_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.orderCustomerExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
          ORDER_DELIVERY_EXPORT_ID,
          ORDER_DELIVERY_TITLE
        );
      }
    });
  }

  //#endregion
  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
